import React from 'react';
import MiniCartProduct from './MiniCartProduct';
import { translate } from '../Services/translation';
import { update } from '../Actions/Cart.action';

const MiniCart = ({ quantity, orderTotal, checkoutUrl, showInfo, toggle, orderRows, update, includeVAT, packageSize }) => (
    <div className="cart cart--mini">
        <a href="#" className="cart__link--block" onClick={() => toggle()}>
            <i className="fal fa-shopping-cart">
                {quantity > 0 && <span className="cart__quantity">{quantity}</span>}
            </i>
            <span className="cart__title hide-for-small-only">{translate('minicart.checkout')}</span>
        </a>
        <div className={`cart__info ${!showInfo ? 'cart__info--hidden' : ''}`}>
            {orderRows.length ? (
                <div className="mini-cart-wrap">
                    <div className="cart__header">
                        <div>
                            <div className="cart__header-circle"></div>
                        </div>
                        <div className="cart__header-text" >{translate('minicart.heading')}</div>
                    </div>
                    <div className="mini-cart-wrap__scroll">
                        {orderRows.map(orderRow => {
                            const { rowSystemId, quantity, packageSize } = orderRow;
                            return (
                                <MiniCartProduct
                                    key={rowSystemId}
                                    product={orderRow}
                                    onCartItemIncrement={() => update(rowSystemId, (quantity + packageSize))}
                                    onCartItemDecrement={() => update(rowSystemId, (quantity - packageSize))}
                                    onCartItemRemove={() => update(rowSystemId, 0)}
                                />
                            );
                        })}
                    </div>
                    <div className="mini-cart-wrap__fixed">
                        <div className="cart__summary">
                            <div className="cart__summary__info-row">
                                <div className="cart__split-row">
                                    <h5>{includeVAT ? translate('minicart.taxesincluded') : translate('minicart.total')}</h5>
                                    <div className="cart__price-row text--right">
                                        <h5 >{orderTotal}</h5>
                                        <span>{translate('alternativevariant.excluding')}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <a href={checkoutUrl}>
                            <button className="button-primary">{translate('minicart.checkout')}</button>
                        </a>
                    </div>
                </div>
            ) : (
                    <h2>{translate('minicart.emptyheading')}</h2>
                )}
        </div>
    </div>
)

export default MiniCart;